export enum RegistrationSourceEnum {
    Unknown = 0,
    Internal = 1,
    Google = 2,
    Office365 = 4,
    SmartSchool = 8,
    Lexipoort = 16,
    LeerId = 32
}
